
import {useContext, useEffect, useRef, useState} from "react";

import Clone from "../utils/clone";
import {appContext} from "../state";
import { useNavigate } from "react-router-dom";
import SignInUp from "../components/SignInUp"
function RouteSignIn(props) {

    return (
        <div className="view auth">
          <SignInUp type="SIGN_IN" onSignInSuccess={props.onSignInSuccess} text="signin_with"></SignInUp>
        </div>
    );
}

export default RouteSignIn;
